<template>
  <router-link
    v-if="currentAd?.id"
    :to="{ name: 'newsDetail', params: { id: currentAd.id } }"
    class="w-full flex relative overflow-hidden rounded-lg"
  >
    <img
      class="rounded-lg w-full h-96 object-fill"
      :src="currentAd?.thumbnail"
      alt="poster-banner"
    />

    <div
      style="background-color: rgba(96, 165, 250, 0.69)"
      class="absolute w-full px-3 py-1 bottom-0 left-0 text-white z-10 rounded-b-lg"
    >
      {{ currentAd?.name }}
    </div>

    <template v-if="currentAd?.has_video">
      <div class="absolute inset-0 rounded-md bg-[rgba(0,0,0,0.74)]"></div>
      <IconPlay class="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[1]" />
    </template>
  </router-link>
</template>

<script>
import IconPlay from '@icons/IconPlay.vue';

export default {
  name: 'NewsBanner',

  components: {
    IconPlay,
  },

  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      adInterval: null,
      adImageIndex: 0,
      time: 0,
      currentAd: null,
    };
  },

  methods: {
    runInterval() {
      this.time = 5000;
      this.adInterval = setInterval(this.changeImage, this.time);
    },

    changeImage() {
      if (!this.content.length) return;

      this.adImageIndex = (this.adImageIndex + 1) % this.content.length;
      this.currentAd = this.content[this.adImageIndex];

      clearInterval(this.adInterval);

      if (this.content.length > 1) {
        this.runInterval();
      }
    },
  },

  mounted() {
    this.currentAd = this.content[0] || null;

    if (this.content.length > 1) {
      this.runInterval();
    }
  },

  unmounted() {
    clearInterval(this.adInterval);
  },
};
</script>
